import React from 'react';
import Scrollbar from '@components/common/scrollbar';
import { useCartQuery } from '@framework/cart/all-cart';
import { motion } from 'framer-motion';
import { fadeInOut } from '@utils/motion/fade-in-out';
import { useUI } from '@contexts/ui.context';
import { IoClose } from 'react-icons/io5';
import CartItem from './cart-item';
import EmptyCart from './empty-cart';
import Link from '@components/ui-old/link';
import cn from 'classnames';
import { useTranslation } from 'next-i18next';
import CartItemLoader from '@components/ui-old/loaders/cart-item-loader';
import CartHeaderLoader from '@components/ui-old/loaders/cart-header-loader';
import CartFooterLoader from '@components/ui-old/loaders/cart-footer-loader';
import { useGuestCartListQuery } from '@framework/cart/all-cart';
import { getCurrentLocationAndLanguage } from '@utils/location';
export default function Cart() {
  const {
    t
  } = useTranslation('common');
  const {
    isAuthorized,
    closeCart
  } = useUI();
  const {
    location
  } = getCurrentLocationAndLanguage();
  const cartQuery = !isAuthorized && location === 'kg' ? useGuestCartListQuery() : useCartQuery();
  const {
    data,
    isLoading
  } = cartQuery;
  let items = [];
  let subTotal = "0";
  if (!isAuthorized && location === 'kg' && data && 'carts' in data && Array.isArray(data.carts) && data.carts.length > 0) {
    items = data.carts[0].items;
    subTotal = data.carts[0].strSubTotal || "0";
  } else if (data) {
    items = (data as any).items || [];
    subTotal = (data as any).subTotal || "0";
  }
  const isEmpty = items.length === 0;
  const itemsCount = !isAuthorized && location === 'kg' && data && 'carts' in data && data.carts.length > 0 ? data.carts[0].cart.totalQuantity : items.reduce((acc: number, item: any) => acc + (item.quantity || 0), 0) || 3;
  if (isLoading) {
    return <div className="flex flex-col justify-between w-full h-full dark:bg-zinc-950 bg-white">
        <CartHeaderLoader />
        <div className="w-full px-5 md:px-7 flex-grow">
          {[...Array(itemsCount)].map((_, idx) => <CartItemLoader key={idx} />)}
        </div>
        <CartFooterLoader />
      </div>;
  }
  return <div className="flex flex-col justify-between w-full h-full bg-background" data-sentry-component="Cart" data-sentry-source-file="cart.tsx">
      <div className="w-full flex justify-between items-center relative ltr:pl-5 ltr:md:pl-7 rtl:pr-5 rtl:md:pr-7 py-0.5 border-b border-neutral-100 dark:border-neutral-600">
        <h2 className="m-0 text-xl font-bold md:text-2xl text-heading dark:text-neutral-200">
          {t('text-shopping-cart')}
        </h2>
        <button className="flex items-center justify-center px-4 py-6 text-2xl text-neutral-500 dark:text-neutral-300 transition-opacity md:px-6 lg:py-8 focus:outline-none hover:opacity-60" onClick={closeCart} aria-label="close">
          <IoClose className="text-black dark:text-neutral-200 mt-1 md:mt-0.5" data-sentry-element="IoClose" data-sentry-source-file="cart.tsx" />
        </button>
      </div>
      {!isEmpty ? <Scrollbar className="flex-grow w-full cart-scrollbar">
          <div className="w-full px-5 md:px-7">
            {items?.map((item: any) => <CartItem item={item} key={item.id} cartId={0} />)}
          </div>
        </Scrollbar> : <motion.div layout initial="from" animate="to" exit="from" variants={fadeInOut(0.25)} className="flex flex-col items-center justify-center px-5 pt-8 pb-5 md:px-7">
          <EmptyCart />
          <h3 className="pt-8 text-lg font-bold text-heading dark:text-neutral-200">
            {t('text-empty-cart')}
          </h3>
        </motion.div>}
      
      <div className="flex flex-col px-5 pt-2 pb-5 md:px-7 md:pb-7" onClick={closeCart}>
        <Link href={isEmpty === false ? '/cart' : '/'} className={cn('w-full px-5 py-3 md:py-4 flex items-center justify-center rounded-md text-sm sm:text-base text-white focus:outline-none transition duration-300 ', isEmpty ? 'cursor-not-allowed bg-neutral-400 dark:bg-neutral-800 hover:dark:bg-neutral-800 hover:bg-neutral-400' : 'bg-heading dark:bg-neutral-800 hover:dark:bg-neutral-900 hover:bg-neutral-600')} data-sentry-element="Link" data-sentry-source-file="cart.tsx">
          <span className="w-full ltr:pr-5 rtl:pl-5 -mt-0.5 py-0.5">
            {t('text-proceed-to-cart')}
          </span>
          <span className="rtl:mr-auto ltr:ml-auto flex-shrink-0 -mt-0.5 py-0.5 flex">
            <span className="ltr:border-l rtl:border-r border-white ltr:pr-5 rtl:pl-5 py-0.5" />
            {subTotal}
          </span>
        </Link>
      </div>
    </div>;
}